import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';
import { AppConfig } from 'src/assets/config/config/app-config';

@Injectable({ providedIn: 'root' })
export class RetentionService {
    apiUrl: string
    constructor(private http: HttpClient,
        private config: AppConfig) {
        this.apiUrl = this.config.getConfig("apiUrl")
    }

    getRetention(): Observable<any> {
        return this.http.get(this.apiUrl + `/compliance/retentiongroup`);
    }

    applyRetention(payload) {
        return this.http.post(this.apiUrl + `/compliance/retention/apply`, payload)
            .pipe(
                map(obj => {
                }), (catchError(this.errorHandler))
            )
    }

    createRetentionGroup(req: any): Observable<any> {
        return this.http.post(this.apiUrl + `/compliance/retentiongroup/create`, req)
            .pipe(
                map(obj => {
                }), (catchError(this.errorHandler))

            )
    }

    getRetentionInfo(docId) {
        return this.http.get(this.apiUrl + `/compliance/retention/document/` + docId);
    }

    updateRetentionGroup(req: any): Observable<any> {

        return this.http.put<any>(this.apiUrl + `/compliance/retentiongroup/update`, req)
            .pipe(
                map(obj => { },
                    err => { alert(catchError(this.errorHandler)); return err; }

                )
            )
    }

    errorHandler(error: HttpErrorResponse) {
        return throwError(error);
    }
}